import { Statistic } from "antd";
import styled from "styled-components";
import { colors } from "../../../utils/constants";

export const NotificationWrapper = styled.div`
  background-color: rgb(${colors.alertRGB});
  border-radius: 5px;
  color: white;
  cursor: pointer;
  padding: 8px 16px;
  position: relative;
  padding-right: 32px;
  z-index: 10;
`;

export const NotificationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const NotificationIcon = styled.div`
  font-size: 24px;
  display: flex;
  align-self: start;
  padding-top: 8px;
`;

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const NotificationTitle = styled.div`
  line-height: 1.5715;
  font-size: 14px;
`;

export const NotificationDescription = styled.div``;

export const StyledCountdown = styled(Statistic.Countdown)<
  Readonly<{ color?: string }>
>`
  .ant-statistic-content-prefix,
  .ant-statistic-content-value,
  .ant-statistic-content-suffix {
    font-size: 14px;
    color: ${({ color }) => {
      return color || "white";
    }};
  }
  .ant-statistic-content {
    font-size: 14px;
  }
`;

export const Minimiser = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
`;

export const MinimisedNotificationWrapper = styled.div`
  position: absolute;
  top: -25px;
  padding-top: 20px;
  background-color: rgb(${colors.alertRGB});
  width: 100px;
  height: 50px;
  border-radius: 1000px;

  cursor: pointer;
  color: white;
  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 10;
`;
